import React from 'react';
import MainLayout from '../../components/MainLayout';

export default () => (
  <MainLayout title="">
    <h1>Not Found</h1>
  </MainLayout>
);
